import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLHANGINGMAN', label: 'Hanging Man', lookback: 11 })
